import React from 'react';
import { useDispatch } from 'react-redux'
import { logout } from '../app/auth.js'
import { getBrandAlt, getHeaderLogoSrc } from '../app/branding.js'
import {Link} from "react-router-dom"
import { useSelector } from 'react-redux'
import { selectTopbarTitle } from '../app/interface.js'
import { IconButton } from '@mui/material'
import MenuBookIcon from '@mui/icons-material/MenuBook'
import { selectCanSeeHelpButtons } from '../app/auth.js'

function TopBar(props) {
  const dispatch = useDispatch()
  const topbarTitle = useSelector(selectTopbarTitle)
  const canSeeHelpButtons = useSelector(selectCanSeeHelpButtons)

  return <nav id="topbar">
    <div className="topbar-logo">
      <img src={getHeaderLogoSrc()} alt={getBrandAlt()} className="brand-logo-header" />
    </div>
    <div className="topbar-menu">
      <Link to={`/`}>
        Home
      </Link>
    </div>
    <div className="topbar-title">{topbarTitle}</div>
    {canSeeHelpButtons && (
      <div className="topbar-manual">
        <IconButton
          color="inherit"
          component="a"
          href="https://learn.everenn-app.fr/index.php/Manuel_d%27utilisateur"
          target="_blank"
          rel="noopener noreferrer"
          title="Manuel utilisateur"
          sx={{ color: 'white' }}
        >
          <MenuBookIcon />
        </IconButton>
      </div>
    )}
    <div className="topbar-login">
      <a onClick={() => dispatch(logout())}>Logout</a>
    </div>
  </nav>
}

export default TopBar;